/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/3/16.
 */
'use strict';
angular
	.module('prism-ui.calendars')
	.service('CalendarsQueryService', function ($q, CalendarsResourceFactory, RecordResourceFactory)
{
	var CalendarsQueryService = this;
	var buildDueDateMap = function (data) {
		var returnValue = {};
		var overdueCollection = [];
		var warningCollection = [];
		angular.forEach(data, function (item) {
			var dueDate = new Date(item.dueDate);
			var warningDate = new Date(item.warningDueDate);
			var now = new Date();
			if (dueDate.getTime() <= now.getTime()) {
				overdueCollection.push(item);
			}
			else if (warningDate.getTime() <= now.getTime()) {
				warningCollection.push(item);
			}
			else {
				var dateKey = new Date(dueDate.setHours(0, 0, 0, 0));
				var dateData = returnValue[dateKey];
				if (!dateData) {
					dateData = {
						data: []
					};
					returnValue[dateKey] = dateData;
				}
				dateData.data.push(item);
			}
		});

		if (overdueCollection.length) {
			returnValue.Overdue = {
				position: 0,
				data: overdueCollection,
				style: 'overdue-cal-header'
			};
		}

		if (warningCollection.length) {
			returnValue.Warning = {
				position: 1,
				data: warningCollection,
				style: 'warning-cal-header'
			};
		}
		return returnValue;
	};

	var buildDateHeaderMap = function (data, keyProp) {
		var returnValue = {};
		angular.forEach(data, function (item) {
			var date = new Date(item[keyProp]);
			var dateKey = new Date(date.setHours(0, 0, 0, 0));
			var dateData = returnValue[dateKey];
			if (!dateData) {
				dateData = {
					data: []
				};
				returnValue[dateKey] = dateData;
			}
			dateData.data.push(item);
		});
		return returnValue;
	};

	var buildOrdMap = function (data) {
		return buildDateHeaderMap(data, 'originalReleaseDate');
	};

	var buildFirstLaunchMap = function (data) {
		return buildDateHeaderMap(data, 'earliestLaunchDate');
	};

	var insertSlotData = function (slotData, toInsert) {
		var returnValue = angular.copy(slotData);
		if (returnValue && returnValue.length) {
			angular.forEach(slotData, function (schedule) {
				var toInsertStart = toInsert.start.getTime();
				var toInsertEnd = toInsert.stop.getTime();
				var scheduleStart = schedule.start.getTime();
				var scheduleEnd = schedule.stop.getTime();
				var startsBeforeEnd = toInsertStart >= scheduleStart && toInsertStart <= scheduleEnd;
				var endsAfterStarts = toInsertEnd >= scheduleStart && toInsertStart <= scheduleEnd;

				if (startsBeforeEnd || endsAfterStarts) {
					toInsert.hasConflict = true;
				}
			});
			returnValue.push(toInsert);
		}
		else {
			returnValue = [toInsert];
		}
		return returnValue;
	};

	var handleConflict = function (timeSlot, current, previous, i, endBlock) {
		var conflictPercent = 0;
		current.paddingStart = 0;
		if (current.startMinutes) {
			if (current.stopMinutes < previous.stopMinutes) {
				//var endBlock = angular.copy(previous);
				var previousLeftPct = ((current.startMinutes - previous.startMinutes) / 60) * 100;
				conflictPercent = ((current.stopMinutes - current.startMinutes) / 60) * 100;
				current.paddingEnd = 0;
				previous.blockPct = previousLeftPct;
				current.blockPct -= conflictPercent;
				current.conflictPct = conflictPercent;
				endBlock.blockPct -= conflictPercent + previousLeftPct;
				endBlock.paddingStart = 0;
				var conflictIndex = i + 1;
				var nextSchedule = timeSlot[conflictIndex];
				var previousSchedule = timeSlot[i];
				while (nextSchedule && nextSchedule.hasConflict) {
					var scheduleConflictPct = ((previousSchedule.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
					var conflictWithEndBlockPct = ((nextSchedule.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
					if (previousSchedule.stopMinutes < nextSchedule.startMinutes) {
						conflictPercent = ((previous.stopMinutes - nextSchedule.startMinutes) / 60) * 100;
						nextSchedule.blockPct -= conflictPercent;
						nextSchedule.paddingStart = 0;
						nextSchedule.conflictPct = conflictPercent;
						endBlock.blockPct -= conflictPercent;
						timeSlot.splice(conflictIndex, 0, endBlock);

						return conflictIndex + 2;
					}
					else {
						previousSchedule.conflictPct -= scheduleConflictPct;
						nextSchedule.blockPct -= conflictWithEndBlockPct;
						endBlock.blockPct -= (conflictWithEndBlockPct - scheduleConflictPct);
						nextSchedule.conflictPct = conflictWithEndBlockPct;
						nextSchedule.paddingStart = nextSchedule.paddingEnd = 0;
					}
					conflictIndex++;
					nextSchedule = timeSlot[conflictIndex];
					previousSchedule = timeSlot[conflictIndex - 1];
				}
				timeSlot.splice(conflictIndex, 0, endBlock);
				return conflictIndex + 1;
			}
			else {
				conflictPercent = (Math.abs(previous.stopMinutes - current.startMinutes) / 60) * 100;
				previous.blockPct -= conflictPercent;
				current.blockPct -= conflictPercent;
				current.conflictPct = conflictPercent;
			}
		}
		else if (previous.stopMinutes <= current.stopMinutes){
			conflictPercent = (previous.stopMinutes / 60) * 100;
			current.conflictPct = conflictPercent;
			previous.blockPct = Math.max(previous.blockPct - conflictPercent, 0);
			current.blockPct = Math.max(current.blockPct - conflictPercent, 0);
		}
		else {
			conflictPercent = ((current.stopMinutes - current.startMinutes) / 60) * 100;
			current.conflictPct = conflictPercent;
			current.paddingEnd = 0;
			timeSlot[i-1] = current;
			timeSlot[i] = previous;
			current.conflictPct = conflictPercent;
			previous.blockPct = Math.max(previous.blockPct - conflictPercent, 0);
			current.blockPct = Math.max(current.blockPct - conflictPercent, 0);
		}
		return i;
	};

	var adjustSlotData = function (toAdjust) {
		angular.forEach(toAdjust, function (timeSlot) {
			for (var i = 1; i < timeSlot.length; i++) {
				var current = timeSlot[i];
				var previous = timeSlot[i - 1];
				previous.paddingEnd = 0;
				if (current.hasConflict) {
					i = handleConflict(timeSlot, current, previous, i, angular.copy(previous));
				}
				else {
					current.paddingStart = ((current.start.getMinutes() - previous.stop.getMinutes()) / 60) * 100;
				}
			}
		});
	};

	var createLiveRowData = function(data) {
		var returnValue = {};
		angular.forEach(data, function (item) {
			var start = new Date(item.startTime);
			var stop = new Date(item.stopTime);
			var startHours = start.getHours();
			var startMinutes = start.getMinutes();
			var stopHours = stop.getHours();
			var stopMinutes = stop.getMinutes();
			var blocks = stopHours - startHours;
			var recordingLength = (stop.getTime() - start.getTime()) / 60000;
			var toInsert = {};

			var arrayMarker = angular.copy(startHours);

			if (startMinutes !== 0) {
				// Doesn't start at the top of the hour, but will go through the end of the hour
				if (blocks > 0) {
					toInsert = {
						blockPct: ((60 - startMinutes) / 60) * 100,
						startMinutes: startMinutes,
						stopMinutes: 60,
						paddingStart: (startMinutes / 60) * 100,
						packageId: item.packageId,
						packageName: item.packageName,
						start: start,
						stop: stop
					};
					recordingLength -= (60 - startMinutes);
				}
				// Starts and ends during the same hour but doesn't start at the top of the hour
				else {
					toInsert = {
						blockPct: ((stopMinutes - startMinutes) / 60) * 100,
						paddingStart: (startMinutes / 60) * 100,
						startMinutes: startMinutes,
						stopMinutes: stopMinutes,
						packageName: item.packageName,
						start: start,
						stop: stop,
						packageId: item.packageId
					};
					recordingLength -= stopMinutes - startMinutes;
				}
				toInsert.paddingEnd = 100 - toInsert.paddingStart - toInsert.blockPct;
				returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
				arrayMarker++;
			}
			while (recordingLength >= 60) {
				toInsert = {
					blockPct: 100,
					paddingStart: 0,
					startMinutes: 0,
					stopMinutes: 60,
					paddingEnd: 0,
					packageId: item.packageId,
					packageName: item.packageName,
					start: start,
					stop: stop
				};
				returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
				recordingLength -= 60;
				arrayMarker++;
			}
			if (recordingLength > 0) {
				toInsert = {
					blockPct: (stopMinutes / 60) * 100,
					paddingStart: 0,
					startMinutes: 0,
					stopMinutes: stopMinutes,
					paddingEnd: 0,
					packageId: item.packageId,
					packageName: item.packageName,
					start: start,
					stop: stop
				};
				toInsert.paddingEnd = 100 - toInsert.blockPct;
				returnValue[arrayMarker] = insertSlotData(returnValue[arrayMarker], toInsert);
			}
		});
		adjustSlotData(returnValue);
		return returnValue;
	};

	var buildDateFeedMap = function (data) {
		var returnValue = {};
		angular.forEach(data, function (recording) {
			if (recording.recordStatus === 'cancelled') {
				return;
			}
			var dateKey = new Date (new Date(recording.startTime).setHours(0, 0, 0, 0));
			var dayData = returnValue[dateKey];
			if (!dayData) {
				returnValue[dateKey] = {};
			}
			var feed = returnValue[dateKey][recording.feedName];
			if (!feed) {
				returnValue[dateKey][recording.feedName] = [];
			}
			returnValue[dateKey][recording.feedName].push(recording);
		});
		return returnValue;
	};

	var buildLiveMap = function (data) {
		var liveData = buildDateFeedMap(data);
		var returnValue = {};
		angular.forEach(liveData, function (feedData, dateKey) {
			returnValue[dateKey] = {data: []};
			angular.forEach(feedData, function (dayFeedSchedules, feedKey) {
				dayFeedSchedules.sort(function(a, b) {
					var start1 = new Date(a.startTime).getTime();
					var start2 = new Date(b.startTime).getTime();
					var stop1 = new Date(a.stopTime).getTime();
					var stop2 = new Date(b.stopTime).getTime();
					if (start1 < start2) {
						return -1;
					}
					else if (start1 > start2) {
						return 1;
					}
					else {
						if (stop1 < stop2) {
							return 1;
						}
						else if (stop1 > stop2){
							return -1;
						}
					}
					return 0;
				});
				var row = createLiveRowData(dayFeedSchedules);
				row.feed = feedKey;
				returnValue[dateKey].data.push(row);
			});
		});
		return returnValue;

	};

	CalendarsQueryService.dueDateQuery = function (showDelivered) {
		var deferred = $q.defer();
		CalendarsResourceFactory.dueDateItems({showDelivered: showDelivered}).$promise.then(function (data) {
			deferred.resolve(buildDueDateMap(data));
		});
		return deferred.promise;
	};

	CalendarsQueryService.ordQuery = function (showDelivered) {
		var deferred = $q.defer();
		CalendarsResourceFactory.ordItems({showDelivered: showDelivered}).$promise.then(function (data) {
			deferred.resolve(buildOrdMap(data));
		});
		return deferred.promise;
	};

	CalendarsQueryService.firstLaunchQuery = function (showDelivered) {
		var deferred = $q.defer();
		CalendarsResourceFactory.firstLaunchItems({showDelivered: showDelivered}).$promise.then(function (data) {
			deferred.resolve(buildFirstLaunchMap(data));
		});
		return deferred.promise;
	};

	//
	// Record schedule data is pulled from the ABC server, but
	// other record properties (such as Elemental status) are only
	// available from the Live Clipping server.
	//
	// This function is used to grab this extra schedule data
	// from the Live Clipping server and add necessary properties
	// to the data obtained from the ABC server, for use in the
	// Live Schedule calendar.
	//
	var augmentScheduleData = function (recordings) {
		var recordingPromises = {};
		angular.forEach(recordings, function (recording) {
			recordingPromises[recording.liveRecordId] = RecordResourceFactory
				.get({id: recording.liveRecordId})
				.$promise;
		});

		var deferred = $q.defer();
		$q.all(recordingPromises).then(function (recordingSchedules) {
			var augmentedSchedules = recordings.map(function (recording) {
				// grab any properties we
				// need from LC server schedule
				recording.recordStatus = recordingSchedules[recording.liveRecordId].status;
				return recording;
			});
			deferred.resolve(augmentedSchedules);
		});
		return deferred.promise;
	};

	CalendarsQueryService.liveRecordingsQuery = function (showDelivered) {
		var deferred = $q.defer();
		CalendarsResourceFactory.liveRecordingsItems({showDelivered: showDelivered}).$promise.then(function (data) {
			augmentScheduleData(data).then(function (recordings) {
				var liveMap = buildLiveMap(recordings);
				deferred.resolve(liveMap);
			});
		});
		return deferred.promise;
	};
});
